import React from 'react';
import { Info, DownloadSimple } from '@phosphor-icons/react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { trackDownloadShotImage } from '../../../../analytics';

import { Tooltip } from '../../../../components/general';

import { getShotImage } from '../../../../utils';

interface Props {
  className?: string;
}

const HlReelStoryboard: React.FC<Props> = (props) => {
  const { className } = props;

  const wildcard = getShotImage('portrait');

  type FramesBlock = {
    text: string | React.ReactNode;
    images: { src: any; alt: string; withBorder?: true }[];
  };

  const wildcardBlock: FramesBlock = {
    text: (
      <>
        Personalised clips will are added here{' '}
        <Link to={getShotImage('zip')} onClick={trackDownloadShotImage}>
          <DownloadSimple />
        </Link>
      </>
    ),
    images: [{ src: wildcard, alt: 'Wildcard Frame', withBorder: true }],
  };

  const frames: FramesBlock[] = [
    {
      text: 'Intro',
      images: [
        {
          src: require('../../../../assets/upload images/reel/1. intro.jpg'),
          alt: 'Intro Frame',
        },
      ],
    },
    wildcardBlock,
    {
      text: 'Mix of close-ups, group shots, etc.',
      images: [
        {
          src: require('../../../../assets/upload images/reel/2. speaker.jpg'),
          alt: 'Speaker Frame',
        },
        {
          src: require('../../../../assets/upload images/reel/3. crowd.jpg'),
          alt: 'Crowd Frame',
        },
        {
          src: require('../../../../assets/upload images/reel/4. close-up.jpg'),
          alt: 'Close-Up Frame',
        },
      ],
    },
    wildcardBlock,
    {
      text: 'Mix of close-ups, group shots, etc.',
      images: [
        {
          src: require('../../../../assets/upload images/reel/5. speaker.jpg'),
          alt: 'Speaker Frame',
        },
        {
          src: require('../../../../assets/upload images/reel/6. photo wall.jpg'),
          alt: 'Photo Wall Frame',
        },
      ],
    },
    {
      text: 'Outro',
      images: [
        {
          src: require('../../../../assets/upload images/reel/7. outro.jpg'),
          alt: 'Outro Frame',
        },
      ],
    },
  ];

  return (
    <div className={classNames('hidden md:flex flex-col gap-2', className)}>
      <div className="font-semibold">
        Highlight Reel Example{' '}
        <Tooltip
          text="This is just an example, your highlight reel may look a little different"
          className="inline-block text-center cursor-pointer hover:text-primary-900"
        >
          <Info weight="fill" />
        </Tooltip>
      </div>

      <div className="flex gap-4">
        {frames.map((block, index) => (
          <div className="w-min" key={index}>
            <div className="flex gap-4">
              {block.images.map((img) => (
                <img
                  src={img.src}
                  alt={img.alt}
                  className={classNames(
                    'shrink-0 w-[var(--reel-example-frame-width)] aspect-[9/16] rounded-md',
                    { 'border border-black': img.withBorder },
                  )}
                  key={img.src}
                />
              ))}
            </div>

            <div className="w-full mt-2 text-[0.5rem] lg:text-xs text-center">
              <div className="h-2 border border-t-0 border-black" />
              <div className="w-1/2 h-2 border-r border-black" />
              <div>{block.text}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HlReelStoryboard;
